module.exports = __webpack_public_path__ + "img/reference-biomoritz.bc1e9006.jpg";